import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flag-group" }
const _hoisted_2 = {
  key: 1,
  class: "link-all-flag"
}

import { computed, ComputedRef, PropType } from "vue";
import { Country } from "@/stores/data";
import { useAppStore } from "@/stores/app";
import PopupCountries from "@/components/popups/PopupCountries.vue";
import CountryIcon from "@/components/icons/CountryIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BundleCountries',
  props: {
  countries: {
    type: Array as PropType<Array<Country>>,
    required: true,
    default: () => [],
  },
  requestedCountries: {
    type: Array as PropType<Array<Country>>,
    required: true,
    default: () => [],
  },
  showMaxCountriesLength: { type: Number },
  viewButton: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const appStore = useAppStore();

const filteredCountries: ComputedRef<Country[]> = computed(() => {
  if (props.showMaxCountriesLength) {
    const countries: Country[] = [];

    props.requestedCountries.forEach((c) => {
      countries.push(c);
    });

    props.countries.forEach((c) => {
      const countryExist = countries.find((country) => country.id === c.id);
      if (!countryExist) countries.push(c);
    });

    return countries.splice(0, props.showMaxCountriesLength);
  }

  const countries: Country[] = [
    ...(props.requestedCountries?.length ? props.requestedCountries : []),
  ];

  return countries.splice(0, 2);
});

function viewAll(): void {
  appStore.showPopup({
    component: PopupCountries,
    props: {
      countries: props.countries,
      requestedCountries: props.requestedCountries,
    },
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredCountries.value, (country, index) => {
      return (_openBlock(), _createElementBlock("figure", { key: index }, [
        _createVNode(CountryIcon, { country: country }, null, 8, ["country"])
      ]))
    }), 128)),
    (__props.viewButton)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "flag-group__view",
          onClick: viewAll
        }, " View all "))
      : (__props.countries.length - filteredCountries.value.length)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, " +" + _toDisplayString(__props.countries.length - filteredCountries.value.length), 1))
        : _createCommentVNode("", true)
  ]))
}
}

})